import { loadIconImports } from './dynamicIconNodes';

/**
 * Starts fetching the Lucide icon map without waiting for an icon to render.
 *
 * `SafeDynamicIcon` keeps the map off the critical path behind a dynamic
 * import, but a screen that does show icons would otherwise not begin the fetch
 * until it has rendered. Calling this during boot overlaps the two.
 */
export function preloadDynamicIcons(): void {
  void loadIconImports();
}
